import axios from "axios";

const APIEP = axios.create({
  baseURL: "https://api-envy.adcm.co.th",
});

export default APIEP;